import { useEffect, useState } from "react";
import { navItems, hotKeywords } from "@/mocks/home";

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [hint, setHint] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  const handleSearch = () => {
    if (!keyword.trim()) {
      setHint("先输入想看的关键词，例如「今日最新瓜」");
      return;
    }
    setHint(`已为你筛选「${keyword.trim()}」相关速递，结果为演示展示`);
  };

  return (
    <header className="fixed left-0 right-0 top-0 z-50">
      <div className="flex h-9 items-center justify-between bg-primary-600 px-4 text-[11px] text-background-50 md:px-8 md:text-xs">
        <div className="flex items-center gap-2">
          <span className="inline-flex h-2 w-2 rounded-full bg-accent-300 animate-softPulse" />
          <span className="whitespace-nowrap">今日已上架 128 条新料 · 最近一条 2 分钟前发出</span>
        </div>
        <div className="hidden items-center gap-5 md:flex">
          <a href="#trust" className="transition-colors hover:text-secondary-200">核实标准</a>
          <a href="#talk" className="transition-colors hover:text-secondary-200">社区规则</a>
          <a href="#faq" className="transition-colors hover:text-secondary-200">更正记录</a>
        </div>
      </div>

      <div
        className={`transition-all duration-300 ${
          solid
            ? "border-b border-background-200 bg-background-50/95 backdrop-blur"
            : "bg-gradient-to-b from-foreground-950/70 to-transparent"
        }`}
      >
        <div className="flex h-16 items-center justify-between gap-3 px-4 md:px-8 lg:h-[72px]">
          <a href="#top" className="flex shrink-0 items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 md:h-10 md:w-10">
              <i className="ri-fire-line text-lg text-background-50" />
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-logo text-xl transition-colors md:text-2xl ${
                  solid ? "text-foreground-950" : "text-background-50"
                }`}
              >
                黑料一区
              </span>
              <span
                className={`mt-0.5 text-[10px] tracking-widest transition-colors ${
                  solid ? "text-foreground-500" : "text-background-200/80"
                }`}
              >
                XINLIAO · 速递
              </span>
            </span>
          </a>

          <nav className="hidden items-center gap-0.5 lg:flex">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`rounded-md px-3 py-2 text-sm transition-colors ${
                  solid
                    ? "text-foreground-700 hover:bg-primary-100/70 hover:text-primary-700"
                    : "text-background-100 hover:bg-background-50/15 hover:text-background-50"
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              type="button"
              aria-label="搜索速递"
              onClick={() => {
                setSearchOpen((v) => !v);
                setMenuOpen(false);
              }}
              className={`flex h-9 w-9 cursor-pointer items-center justify-center rounded-full transition-colors ${
                solid
                  ? "bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
                  : "bg-background-50/15 text-background-50 hover:bg-background-50/25"
              }`}
            >
              <i className={searchOpen ? "ri-close-line" : "ri-search-line"} />
            </button>
            <a
              href="#talk"
              className="hidden items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
            >
              <i className="ri-megaphone-line" />
              我要爆料
            </a>
            <button
              type="button"
              aria-label="展开导航"
              onClick={() => {
                setMenuOpen((v) => !v);
                setSearchOpen(false);
              }}
              className={`flex h-9 w-9 cursor-pointer items-center justify-center rounded-full transition-colors lg:hidden ${
                solid
                  ? "bg-background-100 text-foreground-700"
                  : "bg-background-50/15 text-background-50"
              }`}
            >
              <i className={menuOpen ? "ri-close-line" : "ri-menu-line"} />
            </button>
          </div>
        </div>

        {searchOpen && (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-4 md:px-8">
            <div className="flex flex-col gap-3 sm:flex-row">
              <div className="flex flex-1 items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2.5">
                <i className="ri-search-line text-foreground-400" />
                <input
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleSearch();
                  }}
                  placeholder="搜索今日最新瓜、综艺吃瓜、剧组动态…"
                  className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
                />
              </div>
              <button
                type="button"
                onClick={handleSearch}
                className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                速看新料
              </button>
            </div>
            <div className="mt-3 flex flex-wrap items-center gap-2">
              <span className="text-xs text-foreground-500">热词：</span>
              {hotKeywords.map((word) => (
                <button
                  key={word}
                  type="button"
                  onClick={() => setKeyword(word)}
                  className="cursor-pointer rounded-full border border-background-300 bg-background-100 px-3 py-1 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
                >
                  {word}
                </button>
              ))}
            </div>
            {hint && <p className="mt-3 text-xs text-primary-700">{hint}</p>}
          </div>
        )}

        {menuOpen && (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
            <nav className="flex flex-col">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setMenuOpen(false)}
                  className="flex items-center justify-between border-b border-background-200 py-3 text-sm text-foreground-800 last:border-b-0"
                >
                  {item.label}
                  <i className="ri-arrow-right-s-line text-foreground-400" />
                </a>
              ))}
            </nav>
            <a
              href="#talk"
              onClick={() => setMenuOpen(false)}
              className="mt-4 flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50"
            >
              <i className="ri-megaphone-line" />
              我要爆料
            </a>
          </div>
        )}
      </div>
    </header>
  );
}